import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_EEX_Proveedores_Listar = async () => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Proveedores/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_Leer = async (IdProveedor) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Proveedores/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdProveedor);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_LeerPorDNI = async (DNI, Password) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_LeerPorDNI"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Proveedores/LeerPorDNI/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(DNI) + "/" +
            TratamientoDeParametroParaURI(Password));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_EEX_Proveedores/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Modificar";

    try {
        await llamadaAPI_PUT("ABM_EEX_Proveedores/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_Generar_JSON = async (IdProveedor,
    MultiPlanta, MultiEmpresa, RazonSocial, Apellido, Nombres, CUIT, IdTipoIVA, CodigoCuentaContableDefault, Observaciones,
    CBU, Banco, TipoCuenta, NroCuenta, CodigoCondicionVenta, AgenciaImpositiva, NombreFantasia, CBUResponsable, Categoria,
    CUITCuenta, OpAutGener, OpAutIdCliente, OpAutIdTipoDocVenta, OpAutCodigoSubCC, OpAutCodigoCuentaFinanciera,
    OpAutCodigoPlantaVenta, Agrupador, 
    ListPlantas, ListEmpresas, Locaciones) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Generar_JSON";

    try {

        const listaEmpresasConCodigo = (ListEmpresas && ListEmpresas.length > 0
            ? ListEmpresas
            : [{
                ABM_ZON_Empresas_CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_EEX_Proveedores_IdProveedor: IdProveedor,
                Descripcion: "Default"
            }]
        ).map(empresa => ({
            ...empresa,
            ABM_EEX_Proveedores_IdProveedor: IdProveedor
        }));

        const listaPlantasConCodigo = (ListPlantas && ListPlantas.length > 0
            ? ListPlantas
            : [{
                ABM_ZON_Plantas_CodigoPlanta: localStorage.getItem("CodigoPlanta"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_EEX_Proveedores_IdProveedor: IdProveedor,
                Descripcion: "Default"
            }]
        ).map(planta => ({
            ...planta,
            ABM_EEX_Proveedores_IdProveedor: IdProveedor
        }));
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdEstado: 10,
            IdProveedor: IdProveedor,
            MultiPlanta: MultiPlanta,
            MultiEmpresa: MultiEmpresa,
            RazonSocial: RazonSocial,
            Apellido: Apellido,
            Nombres: Nombres,
            CUIT: CUIT,
            IdTipoIVA: IdTipoIVA,
            CodigoCuentaContableDefault: CodigoCuentaContableDefault,
            Observaciones: Observaciones,
            CBU: CBU,
            Banco: Banco,
            TipoCuenta: TipoCuenta,
            NroCuenta: NroCuenta,
            CodigoCondicionVenta: CodigoCondicionVenta,
            AgenciaImpositiva: AgenciaImpositiva,
            NombreFantasia: NombreFantasia,
            CBUResponsable: CBUResponsable,
            Categoria: Categoria,
            CUITCuenta: CUITCuenta,
            OpAutGener: OpAutGener,
            OpAutIdCliente: OpAutIdCliente,
            OpAutIdTipoDocVenta: OpAutIdTipoDocVenta,
            OpAutCodigoSubCC: OpAutCodigoSubCC,
            OpAutCodigoCuentaFinanciera: OpAutCodigoCuentaFinanciera,
            OpAutCodigoPlantaVenta: OpAutCodigoPlantaVenta,
            Agrupador: Agrupador,
            ListPlantas: listaPlantasConCodigo,
            ListEmpresas: listaEmpresasConCodigo,
            Locaciones: Locaciones
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Proveedores_Eliminar = async (IdProveedor) => {
    const NombreFuncion = "function_ABM_EEX_Proveedores_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_EEX_Proveedores/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            IdProveedor);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};